import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { FormGroup, FormControl, HelpBlock, ControlLabel } from 'react-bootstrap';
import FormSelect from '../../components/common/FormSelect';
import FormValidationService from '../../shared/form/FormValidationService';

interface IProductTypeFormProps {
    name: string;
    errors: any;
    onChange: (e: any) => void;
    types: { id: number; name: string }[];
    productTypeType: number;
    save: (e: any) => void;
}

const ProductTypeForm = (props: IProductTypeFormProps) => {
    return (
        <form onSubmit={props.save}>
            <FormGroup
                validationState={FormValidationService.getValidationState(props.errors.name)}
            >
                <ControlLabel>{Translate('product-types/form/input-label/name')}</ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="name"
                    value={props.name ? props.name : ''}
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors.name}</HelpBlock>
            </FormGroup>
            <FormGroup
                validationState={FormValidationService.getValidationState(
                    props.errors.productTypeType
                )}
                className="product-type-form"
            >
                <ControlLabel>{Translate('product-types/form/select-label/type')}</ControlLabel>
                <FormSelect
                    name="productTypeType"
                    onChange={props.onChange}
                    value={props.productTypeType.toString()}
                    defaultTranslateKey="product-types/form/type/select-default-value"
                >
                    {props.types.map((t: { id: number; name: string }) => {
                        return (
                            <option key={t.id} value={t.id.toString()}>
                                {Translate(t.name)}
                            </option>
                        );
                    })}
                </FormSelect>
                <HelpBlock>{props.errors.productTypeType}</HelpBlock>
            </FormGroup>
        </form>
    );
};

export default ProductTypeForm;
